module.exports = __webpack_public_path__ + "assets/img/copy.1fd65f70.png";